import { render, staticRenderFns } from "./North.vue?vue&type=template&id=4e12a157&"
import script from "./North.vue?vue&type=script&lang=js&"
export * from "./North.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports